import script from "./mainButton.vue?vue&type=script&setup=true&lang=js"
export * from "./mainButton.vue?vue&type=script&setup=true&lang=js"

import "./mainButton.vue?vue&type=style&index=0&id=5d5ee02f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d5ee02f"]])

export default __exports__